export default __webpack_public_path__ + "static/media/bg_orange_02.c1e07765.png";